import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import adminReducer from '../reducers';

const mainReducer = combineReducers({setInfoData:adminReducer, bags:adminReducer, products:adminReducer});

export default createStore(mainReducer,applyMiddleware(thunk));